<template>
	<div id="app">
		<router-view v-wechat-title="$route.meta.title"></router-view>
	</div>
</template>

<script>
	export default {
		name: 'app',
		components: {

		},
		mounted() {
			this.feedBack();
		},
		methods: {
			feedBack() {
				let desc = "官网3.0监测";
				let index = 66;
				// 传入API名以及请求参数对象
				this.jsp('index/EInvoice/count_flow', {
					"banner_index": index,
					"banner_desc": desc,
				}, ).then((data) => {
				}).catch((err) => {
				})
			},
		}

	}
</script>

<style>
	@font-face {
	  font-family: 'Alibaba-PuHuiTi-M';
	  font-display: swap;
	  src: url('//at.alicdn.com/t/webfont_2808ykgjzd7.eot'); /* IE9*/
	  src: url('//at.alicdn.com/t/webfont_2808ykgjzd7.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
	  url('//at.alicdn.com/t/webfont_2808ykgjzd7.woff2') format('woff2'),
	  url('//at.alicdn.com/t/webfont_2808ykgjzd7.woff') format('woff'), /* chrome、firefox */
	  url('//at.alicdn.com/t/webfont_2808ykgjzd7.ttf') format('truetype'), /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/
	  url('//at.alicdn.com/t/webfont_2808ykgjzd7.svg#AlibabaPuHuiTiM') format('svg'); /* iOS 4.1- */
	}
	
	@font-face {
	  font-family: 'Alibaba-PuHuiTi-R';
	  font-display: swap;
	  src: url('//at.alicdn.com/t/webfont_bep7d5ok8u.eot'); /* IE9*/
	  src: url('//at.alicdn.com/t/webfont_bep7d5ok8u.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
	  url('//at.alicdn.com/t/webfont_bep7d5ok8u.woff2') format('woff2'),
	  url('//at.alicdn.com/t/webfont_bep7d5ok8u.woff') format('woff'), /* chrome、firefox */
	  url('//at.alicdn.com/t/webfont_bep7d5ok8u.ttf') format('truetype'), /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/
	  url('//at.alicdn.com/t/webfont_bep7d5ok8u.svg#Alibaba-PuHuiTi-Regular') format('svg'); /* iOS 4.1- */
	}


	* {
		font-family: Alibaba-PuHuiTi-R;
	}

	#app {
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;

	}

	@font-face {
		font-family: 'iconfont';
		/* project id 1631181 */
		src: url('//at.alicdn.com/t/font_1631181_ubm4geq83yr.eot');
		src: url('//at.alicdn.com/t/font_1631181_ubm4geq83yr.eot?#iefix') format('embedded-opentype'),
			url('//at.alicdn.com/t/font_1631181_ubm4geq83yr.woff2') format('woff2'),
			url('//at.alicdn.com/t/font_1631181_ubm4geq83yr.woff') format('woff'),
			url('//at.alicdn.com/t/font_1631181_ubm4geq83yr.ttf') format('truetype'),
			url('//at.alicdn.com/t/font_1631181_ubm4geq83yr.svg#iconfont') format('svg');
	}

	.iconfont {
		font-family: 'iconfont';
	}

	body {
		margin: 0;
		padding: 0;
	}

	.amplification_1_3 {
		transition: 1s;
	}

	.amplification_1_3:hover {
		transform: scale(1.3);
	}

	.amplification_1_2 {
		transition: 1s;
	}

	.amplification_1_2:hover {
		transform: scale(1.2);
	}

	.amplification_1_1 {
		transition: 1s;
	}

	.amplification_1_1:hover {
		transform: scale(1.1);
	}

	.amplification_1_5 {
		transition: 1s;
	}

	.amplification_1_5:hover {
		transform: scale(1.5);
	}
</style>
